import React, { useState } from "react";
import axios from "axios";
import { REPORTS_API_ROOT } from "./config/api";
import DataGrid, {
  Column,
  Summary,
  TotalItem,
  GroupItem,
  Paging,
  Pager,
  Grouping,
  GroupPanel,
  FilterRow,
} from "devextreme-react/data-grid";
import "devextreme/dist/css/dx.light.css";



export default function MonthlyBudgetGrid() {
  const API_BASE = REPORTS_API_ROOT;

  const [selectedMonth, setSelectedMonth] = useState(() => {
    const today = new Date();
    return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}`;
  });

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [proceeded, setProceeded] = useState(false);

const fetchMonthlyData = async () => {
  try {
    setLoading(true);
    const [year, month] = selectedMonth.split("-");

    const res = await axios.get(
      `${API_BASE}/api/monthlybudget?year=${year}&month=${month}`
    );

    const formattedData = (res.data || []).map((item, index) => ({
  id: index + 1,
  ...item,
  BUDGET: Number(item.BUDGET ?? 0),
  AMOUNT2: Number(item.AMOUNT2 ?? 0),
  BALANCE: Number(item.BALANCE ?? 0),
  DESCRIPTION: item.DESCRIPTION ?? "",
  RP_MODE: item.RP_MODE ?? "",
  RP_PAID_TO: item.RP_PAID_TO ?? "",
}));


    setData(formattedData);  
    console.log(res.data[0])
 // ✅ only this
    setProceeded(true);
  } catch (err) {
    console.error(err);
    alert("Error loading Monthly Budget data");
    setProceeded(false);
  } finally {
    setLoading(false);
  }
};


  const columnCaptions = {
    DESCRIPTION: "Description",
    DATE: "Date",
    BUDGET: "Budget",
    AMOUNT2: "Amount",
    BALANCE: "Balance",
    docno: "DocNo",
    RP_DOCDATE: "Docdate",
    RP_CHEQUE_DATE: "Cheque Date",
    RP_MODE: "Mode",
    RP_PAID_TO: "Paid To",
  };

  const columns = [
    
    "DESCRIPTION",
    "BUDGET",
    "AMOUNT2",
    "BALANCE",
    "DATE",
    "docno",
    
    "RP_DOCDATE",
    "RP_CHEQUE_DATE",
    "RP_MODE",
    "RP_PAID_TO",
  ];

  return (
  <div className="mb-page">

    <div className="mb-container">

      {/* Toolbar */}
      <div className="mb-toolbar">
        <input
          type="month"
          value={selectedMonth}
          onChange={(e) => setSelectedMonth(e.target.value)}
          className="mb-input"
        />

       <button
            onClick={fetchMonthlyData}
            style={{
              padding: "10px 20px",
              borderRadius: "10px",
              border: "none",
              background: "#198754",
              color: "#fff",
              fontWeight: 600,
              cursor: "pointer",
              fontSize: "14px",
            }}
          >
            {loading ? "Loading..." : "Proceed"}
          </button>
        </div>

{/* Data Grid */}
{proceeded && data.length > 0 && (
<DataGrid
  dataSource={data}
  keyExpr="docno"
  showBorders={true}
  rowAlternationEnabled={true}
  columnAutoWidth={true}
  wordWrapEnabled={true}
  allowColumnReordering={true}
  columnResizingMode="nextColumn"
  height="85vh"
  scrolling={{ mode: "standard" }}
  alignGroupSummaryInGroupRow={true}
  style={{
    fontFamily: '"Segoe UI", sans-serif',
    fontSize: "13px",
    color: "#374151",
  }}
>

  {/* ✅ REMOVE PAGINATION */}
  <Paging enabled={false} />
  <Pager visible={false} />

  {/* GROUPING */}
  <GroupPanel visible={true} />
  <Grouping autoExpandAll={false} />

  {/* FILTER ROW */}
  <FilterRow visible={true} />

 <Column
  dataField="DESCRIPTION"
  caption="Description"
  groupIndex={0}
  width={350}
  alignment="left"   // ✅ add this
  showWhenGrouped={true}
  groupCellTemplate={(cellElement, cellInfo) => {
    cellElement.textContent = cellInfo.value;
  }}
/>



  {columns
  .filter((col) => col !== "DESCRIPTION")
  .map((col) => (
    <Column
      key={col}
      dataField={col}
      caption={columnCaptions[col]}
      dataType={
        ["BUDGET", "AMOUNT2", "BALANCE"].includes(col)
          ? "number"
          : ["RP_DOCDATE", "RP_CHEQUE_DATE"].includes(col)
          ? "datetime"
          : "string"
      }
      format={
        ["BUDGET", "AMOUNT2", "BALANCE"].includes(col)
          ? { type: "fixedPoint", precision: 2 }
          : ["RP_DOCDATE", "RP_CHEQUE_DATE"].includes(col)
          ? "yyyy-MM-dd HH:mm"
          : undefined
      }

      alignment={
        ["BUDGET", "AMOUNT2", "BALANCE"].includes(col)
          ? "left"          // ✅ numbers right
          : ["DATE", "RP_DOCDATE", "RP_CHEQUE_DATE"].includes(col)
          ? "left"         // ✅ dates center
          : "left"           // ✅ text left
      }

      allowFiltering={true}
    />
  ))}


<Summary>

  {/* GROUP SUMS */}
  <GroupItem
    column="BUDGET"
    summaryType="sum"
    displayFormat="{0}"
    valueFormat={{ type: "fixedPoint", precision: 2 }}
    alignByColumn={true}
  />

  <GroupItem
    column="AMOUNT2"
    summaryType="sum"
    displayFormat="{0}"
    valueFormat={{ type: "fixedPoint", precision: 2 }}
    alignByColumn={true}
  />

  <GroupItem
    column="BALANCE"
    summaryType="sum"
    displayFormat="{0}"
    valueFormat={{ type: "fixedPoint", precision: 2 }}
    alignByColumn={true}
  />

  {/* FOOTER TOTALS (NO "Sum") */}
  <TotalItem
    column="BUDGET"
    summaryType="sum"
    displayFormat="{0}"
    valueFormat={{ type: "fixedPoint", precision: 2 }}
  />

  <TotalItem
    column="AMOUNT2"
    summaryType="sum"
    displayFormat="{0}"
    valueFormat={{ type: "fixedPoint", precision: 2 }}
  />

  <TotalItem
    column="BALANCE"
    summaryType="sum"
    displayFormat="{0}"
    valueFormat={{ type: "fixedPoint", precision: 2 }}
  />

</Summary>

</DataGrid>

)}
        {proceeded && data.length === 0 && !loading && (
          <div style={{ padding: "20px", textAlign: "center", color: "#6b7280" }}>
            No data available for the selected month.
          </div>
        )}
      </div>

    {/* CSS */}
    <style>
      {`
        /* ===== PAGE RESET ===== */
        html, body {
          margin: 0;
          padding: 0;
          width: 100%;
          overflow-x: hidden;
          background: #f4f6f9;
        }

        * {
          box-sizing: border-box;
        }

        /* ===== MAIN PAGE ===== */
        .mb-page {
          width: 100%;
          min-height: 100vh;
          background: #f4f6f9;
          padding: 12px;
        }

        /* Container */
        .mb-container {
          width: 100%;
          max-width: 1400px;
          margin: auto;
          background: #fff;
          border-radius: 14px;
          padding: 18px;
          box-shadow: 0 4px 14px rgba(0,0,0,0.08);
        }

        /* Toolbar */
        .mb-toolbar {
          display: flex;
          gap: 12px;
          align-items: center;
          flex-wrap: wrap;
          margin-bottom: 15px;
        }

        .mb-input {
          padding: 10px 12px;
          border-radius: 10px;
          border: 1px solid #d1d5db;
          font-size: 14px;
          min-width: 180px;
        }

        .mb-btn {
          padding: 10px 20px;
          border-radius: 10px;
          border: none;
          background: #198754;
          color: #fff;
          font-weight: 600;
          cursor: pointer;
          font-size: 14px;
          min-width: 130px;
        }

        /* Grid wrapper */
        .mb-grid-wrapper {
          width: 100%;
          overflow-x: auto;   /* ✅ only grid scrolls in mobile */
        }

        /* No data */
        .mb-no-data {
          padding: 20px;
          text-align: center;
          color: #6b7280;
        }

        /* ===== HEADER STICKY ===== */
        .dx-datagrid-headers {
          position: sticky !important;
          top: 0;
          z-index: 1000;
          background: #198754 !important;
        }

        .dx-datagrid-headers .dx-datagrid-text-content {
          color: #fff !important;
          font-weight: 700;
        }

        .dx-datagrid-headers .dx-header-row > td {
          background: #198754 !important;
          border-right: none !important;
        }

        .dx-datagrid-rowsview {
  overflow-y: auto !important;
  max-height: 420px !important;  /* body scroll area */
}

.dx-datagrid-pager {
  display: none !important;
}


        /* ===== FOOTER STICKY ===== */
        .dx-datagrid-total-footer {
          position: sticky !important;
          bottom: 0;
          z-index: 1000;
          background: #f9fafb !important;
          font-weight: 700;
          border-top: 2px solid #d1d5db;
        }

        .dx-datagrid-total-footer td {
          color: #000 !important;
          font-weight: 700;
        }

        .dx-datagrid-total-footer .dx-datagrid-summary-item {
          color: #000 !important;
        }

        .dx-datagrid-filter-row td {
  background: #ffffff !important;
}

.dx-datagrid-group-row td {
  padding-left: 6px !important;
}

.dx-datagrid-group-opened,
.dx-datagrid-group-closed {
  margin-left: -8px !important;
}

        /* Filter row */
.dx-datagrid-filter-row input {
  background: #ffffff !important;   /* ✅ FULL WHITE */
  border: 1px solid #d1d5db !important;
  border-radius: 6px !important;
  padding: 6px 8px !important;
  font-size: 12px !important;
  color: #111827 !important;
  box-shadow: none !important;
}

.dx-datagrid-filter-row input:focus {
  outline: none !important;
  border: 1px solid #198754 !important;  /* optional green border */
}

.dx-editor-cell .dx-texteditor.dx-state-focused::after {
  border-bottom: none !important;
}

        /* ===== MOBILE RESPONSIVE ===== */
        @media (max-width: 768px) {

          .mb-page {
            padding: 0px;  /* ✅ remove left/right grey space */
          }

          .mb-container {
            border-radius: 0px;
            padding: 12px;
            box-shadow: none;
          }

          .mb-toolbar {
            flex-direction: column;
            align-items: stretch;
            gap: 10px;
          }

          .mb-input, .mb-btn {
            width: 100%;
            min-width: unset;
          }

          .mb-grid-wrapper {
            border: 1px solid #e5e7eb;
            border-radius: 10px;
          }
        }
      `}
    </style>
  </div>
);
}
